import { useEffect } from "react";
import {
  pushRecentDoc,
  type RecentDocKind,
} from "./recent-docs";

/** Record open desk doc into ⌘K / Home Recent — plan/35 F. */
export function useRecordRecentDoc(input: {
  companySlug: string | undefined;
  kind: RecentDocKind;
  id: string | undefined;
  label: string | undefined;
  path: string | undefined;
  hint?: string | null;
}) {
  const { companySlug, kind, id, label, path, hint } = input;
  useEffect(() => {
    if (!companySlug || !id || !label || !path) return;
    pushRecentDoc(companySlug, {
      kind,
      id,
      label,
      path,
      hint: hint ?? undefined,
    });
  }, [companySlug, kind, id, label, path, hint]);
}
